<template lang="pug">
  div(ref="group" :class="[classes.group, 'sidebar-context-group']")
    //- ui-label(
    //-   v-if="label"
    //-   :class="[classes.label, labelClass]"
    //-   :disabled="disabled"
    //- ) {{ label }}
    div(ref="container" :class="[classes.root, 'sidebar-context']")
      //- ui-input-text(
      //-   v-if="editable"
      //-   :aria-activedescendant="focused ? focusedOptionId : undefined"
      //-   :aria-controls="$id + '_list'"
      //-   :aria-expanded="overlayVisible"
      //-   aria-haspopup="listbox"
      //-   :aria-invalid="invalid || undefined"
      //-   :aria-label="ariaLabel"
      //-   :aria-lablledby="ariaLabelledBy"
      //-   autocomplete="off"
      //-   :disabled="disabled"
      //-   :class="[classes.input, inputClass]"
      //-   :id='inputId'
      //-   type="text"
      //-   ref="focusInput"
      //-   role="combobox"
      //-   :style="[inputStyle]"
      //-   :tabIndex="!disabled? tabindex : -1"
      //-   :value="editableInputValue"
      //-   @blur="onBlur"
      //-   @focus="onFocus"
      //-   @input="onEditableInput"
      //-   @keydown="onKeyDown"
      //- )
      div(
        :aria-activedescendant="focused ? focusedOptionId : undefined"
        :aria-controls="$id + '_list'"
        :aria-expanded="overlayVisible"
        aria-haspopup="listbox"
        :aria-invalid="invalid || undefined"
        :aria-label="ariaLabel"
        :aria-labelledby="ariaLabelledBy"
        ref="focusInput"
        :id="inputId"
        :class="[classes.value, 'sidebar-context-value']"
        :style="[inputStyle]"
        :tabindex="!disabled ? tabindex : -1"
        role="combobox"
        @blur="onBlur"
        @focus="onFocus"
        @keydown="onKeyDown"
      )
        slot(name="value" :value="d_value" :placeholder="placeholder") {{ displayValue === 'EMPTY_LABEL' ? '&nbsp;' : (displayValue ?? 'empty') }}
      //-TODO: Handle loading icon?
      div(class="switch-link" @click="onClickContainer")
        switch-icon(size="1rem")
        span Change laboratory

      ui-portal(:appendTo="appendTo")
        transition(
          name="ui-connected-overlay"
          @enter="onOverlayEnter"
          @after-enter="onOverlayAfterEnter"
          @leave="onOverlayLeave"
          @after-leave="onOverlayAfterLeave"
        )
          div(
            v-if="overlayVisible"
            :class="[classes.overlay, panelClass, overlayClass]"
            :ref="overlayRef"
            :style="[panelStyle, overlayStyle]"
            @click="onOverlayClick"
            @keydown="onOverlayKeyDown"
          )
            span(
              aria-hidden="true"
              class="ui-hidden-accessible ui-hidden-focusable"
              :data-ui-hidden-accessible="true"
              :data-ui-hidden-focusable="true"
              ref="firstHiddenFocusableElementOnOverlay"
              role="presentation"
              :tabindex="0"
              @focus="onFirstHiddenFocus"
            )
            slot(
              name="header"
              :value="d_value"
              :options="visibleOptions"
            )
            div(v-if="filter" :class="classes.header")
              //- add icon when we make an icon available
              ui-input-text(
                autocomplete="off"
                class="ui-select-filter"
                :placeholder="filterPlaceholder"
                ref="filterInput"
                role="searchbox"
                type="text"
                :value="filterValue"
                @blur="onFilterBlur"
                @input="onFilterChange"
                @keydown="onFilterKeyDown"
                @vue:mounted="onFilterUpdated"
                @vue:updated="onFilterUpdated"
              )
              span(
                aria-live="polite"
                class="ui-hidden-accessible"
                :data-p-hidden-accessible="true"
                role="status"
              ) {{ filterResultMessageText }}
            div(
              :class="classes.listContainer"
              :style="{ 'max-height': virtualScrollerDisabled ? scrollHeight : '' }"
            )
              virtual-scroller(
                :disabled="virtualScrollerDisabled"
                :items="visibleOptions"
                :style="{ height: scrollHeight }"
                :ref="virtualScrollerRef"
                :tabindex="-1"
                v-bind="virtualScrollerOptions"
              )
                template(
                  v-slot:content="{ styleClass, contentRef, items, getItemOptions, contentStyle, itemSize }"
                )
                  ul(
                    :class="[classes.list, styleClass]"
                    :id="$id + '_list'"
                    :ref="(el) => listRef(el, contentRef)"
                    role="listbox"
                    :style="contentStyle"
                  )
                    template(
                      v-for="(option, i) of items"
                      :key="getOptionRenderKey(option, getOptionIndex(i, getItemOptions))"
                    )
                      li(
                        v-if="isOptionGroup(option)"
                        :class="classes.optionGroup"
                        :id="$id + '_' + getOptionIndex(i, getItemOptions)"
                        role="option"
                        :style="{ height: itemSize ? itemSize + 'px' : undefined }"
                      )
                        slot(
                          name="optiongroup"
                          :option="option.optionGroup"
                          :index="getOptionIndex(i, getItemOptions)"
                        )
                          span(
                            :class="classes.optionGroup"
                          ) {{ getOptionGroupLabel(option.optionGroup) }}
                      li(
                        v-else
                        :aria-disabled="isOptionDisabled(option)"
                        :aria-label="getOptionLabel(option)"
                        :aria-posinset="getAriaPosInset(getOptionIndex(i, getItemOptions))"
                        :aria-selected="isSelected(option)"
                        :aria-setsize="ariaSetSize"
                        :class="classes.option(option, getOptionIndex(i, getItemOptions))"
                        :data-ui-disabled="isOptionDisabled(option)"
                        :data-ui-focused="focusedOptionIndex === getOptionIndex(i, getItemOptions)"
                        :data-ui-selected="isSelected(option)"
                        :id="$id + '_' + getOptionIndex(i, getItemOptions)"
                        role="option"
                        :style="{ height: itemSize ? itemSize + 'px' : undefined }"
                        @click="onOptionSelect($event, option)"
                        @mousemove="onOptionMouseMove($event, getOptionIndex(i, getItemOptions))"
                      )
                        template(v-if="checkmark")
                          check-icon( v-if="isSelected(option)" class="select-check-icon")
                          blank-icon( v-else class="select-blank-icon")
                        slot(
                          :index="getOptionIndex(i, getItemOptions)"
                          name="option"
                          :option="option"
                          :selected="isSelected(option)"
                        )
                          span(:class="classes.optionLabel") {{ getOptionLabel(option) }}
                    li(
                      v-if="filterValue && (!items || (items && items.length === 0))"
                      :class="classes.emptyFilterMessage"
                      role="option"
                      :data-ui-hidden-accessible="true"
                    )
                      slot( name="emptyfilter") {{ emptyFilterMessageText }}
                    li(
                      v-else-if="!options || (options && options.length === 0)"
                      :class="classes.emptyMessage"
                      role="option"
                      :data-ui-hidden-accessible="true"
                    )
                      slot( name="empty") {{ emptyMessageText }}
                template(
                  v-if="$slots.loader"
                  v-slot:loader="{ options }"
                )
                  slot( name="loader" :options="options")
            span(
              v-if="!options || (options && options.length === 0)"
              aria-live="polite"
              class="ui-hidden-accessible"
              :data-ui-hidden-accessible="true"
              role="status"
            )  {{ emptyMessageText }}
            span(
              aria-live="polite"
              class="ui-hidden-accessible"
              :data-ui-hidden-accessible="true"
              role="status"
            )  {{ selectedMessageText }}
            span(
              aria-hidden="true"
              class="ui-hidden-accessible ui-hidden-focusable"
              :data-ui-hidden-accessible="true"
              :data-ui-hidden-focusable="true"
              ref="lastHiddenFocusableElementOnOverlay"
              role="presentation"
              :tabindex="0"
              @focus="onLastHiddenFocus"
            )
</template>


<script>
import Select from '@wholebodyapp/ui-components/src/components/select/select.vue';
import DoubleArrow from '@wholebodyapp/ui-components/src/components/icons/arrow-double-horizontal/arrow-double-horizontal.vue';

export default {
  name: 'SidebarContext',
  components: {
    SwitchIcon: DoubleArrow,
  },
  extends: Select,
};

</script>

<style lang="scss">
@use '@wholebodyapp/design/typography/weights';
@use '@wholebodyapp/design/typography/styles' as *;

.ui-select.sidebar-context {
  background: transparent;
  border: none;
  cursor: default;
  display: flex;
  flex-direction: column;

  &.ui-select.ui-focus {
    border: none;
    outline: none;
  }
}

.ui-select-value.sidebar-context-value {
  cursor: default;
  width: 100%;
  font-weight: weights.$semibold;
  padding: 0;
  margin-bottom: 4px;
}

.switch-link {
  @include type-style($app-ui-10);
  align-items: center;
  cursor: pointer;
  color: var(--primary-text);
  display: flex;
  gap: 4px;
}

</style>
